var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg010Page(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 60 56",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "009---Script",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m59 5v6h-58v-6c0-2.209139 1.790861-4 4-4h50c2.209139 0 4 1.790861 4 4z",
    fill: "#ffe0e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m55 1h-3c2.209139 0 4 1.790861 4 4v6h3v-6c0-2.209139-1.790861-4-4-4z",
    fill: "#ff9ea1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m59 11v40c0 2.209139-1.790861 4-4 4h-50c-2.209139 0-4-1.790861-4-4v-40z",
    fill: "#ffe7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m56 11v40c0 2.209139-1.790861 4-4 4h3c2.209139 0 4-1.790861 4-4v-40z",
    fill: "#ffc9cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m5 55h3c-2.209139 0-4-1.790861-4-4v-46c0-2.209139 1.790861-4 4-4h-3c-2.209139 0-4 1.790861-4 4v46c0 2.209139 1.790861 4 4 4z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m0 43h2v8h-2z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ff414c"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1,
    cy: 47,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m5 56h50c2.7600532-.0033061 4.9966939-2.2399468 5-5v-46c-.0033061-2.76005315-2.2399468-4.99669388-5-5h-50c-2.76005315.00330612-4.99669388 2.23994685-5 5v38c0 .5522847.44771525 1 1 1s1-.4477153 1-1v-31h5c.55228475 0 1-.4477153 1-1s-.44771525-1-1-1h-5v-5c0-1.65685425 1.34314575-3 3-3h50c1.6568542 0 3 1.34314575 3 3v5h-45c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h45v39c0 1.6568542-1.3431458 3-3 3h-50c-1.65685425 0-3-1.3431458-3-3 0-.5522847-.44771525-1-1-1s-1 .4477153-1 1c.00330612 2.7600532 2.23994685 4.9966939 5 5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6,
    cy: 6,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10,
    cy: 6,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 14,
    cy: 6,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m39 7c.5522847 0 1-.44771525 1-1s-.4477153-1-1-1h-1c-.5522847 0-1 .44771525-1 1s.4477153 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m54 7c.5522847 0 1-.44771525 1-1s-.4477153-1-1-1h-11c-.5522847 0-1 .44771525-1 1s.4477153 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m6.948 32c.00324319.8353013.3526495 1.6318753.965 2.2l11.408 10.53c.1841704.1724307.4267109.2688753.679.27.4119729.0003845.7820209-.2519194.9321603-.6355597.1501394-.3836404.0496401-.8200951-.2531603-1.0994403l-11.408-10.53c-.20521118-.1893156-.32193289-.4558011-.32193289-.735s.11672171-.5456844.32193289-.735l5.991-5.53c.4059293-.3750013.4310013-1.0080707.056-1.414s-1.0080707-.4310013-1.414-.056l-5.991 5.535c-.61275116.5678397-.96223783 1.3645969-.965 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m18.679 22.581 2-1.846c.4059293-.3750013.4310013-1.0080707.056-1.414s-1.0080707-.4310013-1.414-.056l-2 1.846c-.4059293.3750014-.4310013 1.0080707-.056 1.414.3750014.4059293 1.0080707.4310013 1.414.056z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m39.321 43.265c-.4059293.3750013-.4310013 1.0080707-.056 1.414s1.0080707.4310013 1.414.056l11.408-10.535c.6153054-.567924.9652568-1.3671599.9652568-2.2045s-.3499514-1.636576-.9652568-2.2045l-11.408-10.526c-.4059293-.3750013-1.0389987-.3499293-1.414.056s-.3499293 1.0389987.056 1.414l11.408 10.53c.2052112.1893156.3219329.4558011.3219329.735s-.1167217.5456844-.3219329.735z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m24.759 39.651 12-14c.3340753-.4212323.2753078-1.0312217-.133041-1.3809275-.4083488-.3497059-1.020119-.3139582-1.384959.0809275l-12 14c-.2485449.2690133-.3301409.6523779-.2126907.9992902.1174502.3469124.415153.6018621.7760016.66456.3608485.0626979.7271025-.0768884.9546891-.3638502z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m47 50c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h3c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m54 52h1c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-1c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg010Page);
export default __webpack_public_path__ + "static/media/010-page.22256e12612b5d04fd2eeb0d7ebc35a6.svg";
export { ForwardRef as ReactComponent };